




























import { Component, Vue } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';
import axios from 'axios';

@Component({
    components: {
        'sbpro-top-nav': SBProTopNav,
        'sbpro-page-header': SBProPageHeader,
        'sbpro-layout-default': SBProLayoutDefault,
        'sbpro-page-section': SBProPageSection,
    },
})

export default class CompanyContact extends Vue {
    form = {
        name: '',
        email: '',
        message: '',
    };

    sub(event : any) {
        event.preventDefault();
        if (this.form.name === '' || this.form.email === '' || this.form.message === '') {
            alert('All fields are required');
        } else {
            axios.post('/mail.php', {
                name: this.form.name,
                email: this.form.email,
                message: this.form.message,
            });
            alert('Message sent');
            this.form.name = '';
            this.form.email = '';
            this.form.message = '';
        }
    }
}
